import React, { useContext, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import AuthContext from "../context/auth/authContext";
const PrivateRoute = ({ location, component: Component, ...rest }) => {
  const { token } = useContext(AuthContext);
  useEffect(() => {
    // if (!token) {
    //   toggleModal();
    // }
    //eslint-disable-next-line
  }, []);

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              state: { showModal: true },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
